import { ProductType } from '@mfe/shared/schema-types';

export function sortByCheapest(productTypes: ProductType[]): ProductType[] {
  if (productTypes.some((product) => !product.prices)) {
    return productTypes;
  }

  return productTypes.slice().sort((a: ProductType, b: ProductType) => {
    const priceA: number = a?.prices?.[0].amount.value ?? 0;
    const priceB: number = b?.prices?.[0].amount.value ?? 0;
    return priceA - priceB;
  });
}
